export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-bourbonlemonadee.383fa914.png";